import { AmbientLight } from "three";
import { useEffect, useRef } from "react";

import {
  RoundedBox,
  ScrollControls,
  Scroll,
  Environment,
  Sparkles,
  Backdrop,
  Float,
  Ring,
  GradientTexture,
} from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { Iphone } from "./components/Iphone";
import baffle from "baffle";
function App() {
  useEffect(() => {
    const target = baffle(".title");
    target.set({
      characters: ".......",
      speed: 100,
    });
    target.start();
    target.reveal(1000, 1000);
  }, []);
  return (
    <>
      <color attach="background" args={["#000000"]} />
      <ambientLight intensity={0.2} />
      <spotLight
        position={[-20, 55, 0]}
        angle={1.3}
        penumbra={1}
        castShadow
        intensity={2}
        shadow-bias={-0.0001}
      />
      <Environment  preset="studio" backgroundBlurriness={0}/>
      <spotLight position={[10, 2, 0]} scale={[1, 3, 10]} />
        <spotLight position={[-10, 2, 0]} scale={[1, 3, 10]} />
      <ScrollControls pages={6} damping={1}>
        <Iphone scale={0.8} />
        <Sparkles size={2} color={"#ffffff"} scale={[10, 10, 10]} />
       
        <Scroll></Scroll>
        <Scroll html style={{ width: "100%" }}>
          <div
            className="row"
            style={{
              position: "absolute",
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              top: `65vh`,
              position: "absolute",
            }}
          >
            <h1
              className="title"
              style={{
                color: "#cdcbca",
                fontSize: "13em",
              }}
            >
              IPHONE
            </h1>
            <h2 style={{
                color: "#cdcbca",
                fontSize: "11em",
              }}>14 PRO</h2>
          </div>

          <div className="row" style={{ position: "absolute", top: `164vh` }}>
            <h2>Introducing the Next Evolution</h2>
            <p>
            Experience innovation like never before with the iPhone 14 Pro. With cutting-edge technology and sleek design, this device redefines what a smartphone can do. From its stunning display to its powerful performance, discover the future of mobile communication.
            </p>
            <button>Read more</button>
          </div>

          <div className="row" style={{ position: "absolute", top: `230vh` }}>
            <div
              className="col"
              style={{ position: "absolute", right: `40px`, width: "640px" }}
            >
              <h2 style={{ maxWidth: "440px" }}>Unleash Your Creativity</h2>
              <p>
              Capture moments in unparalleled clarity with the advanced camera system of the iPhone 14 Pro. From professional-grade photography to immersive gaming experiences, explore the endless possibilities that await with this revolutionary device. Elevate your creativity and stay connected like never before.
              </p>
              <button>Read more</button>
            </div>
          </div>

          <h2
            style={{
              position: "absolute",
              top: "350vh",
              left: "50%",
              transform: `translate(-50%,-50%)`,
            }}
          >
            Cutting-Edge of Technology
          </h2>

          <button className="buy"
            style={{
              position: "absolute",
              top: `590vh`,
              left: "50%",
            }}
          >
            Buy now
          </button>
        </Scroll>
      </ScrollControls>
    </>
  );
}

export default App;
